import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { navItems, WHATSAPP_LINK, LOGO_URL } from "../../mock";
import ColorfulBrand from "./ColorfulBrand";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#0b0a12]/90 backdrop-blur-md border-b border-white/5 py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 flex items-center justify-between">
        {/* Logo */}
        <a href="#inicio" className="flex items-center gap-3 group">
          <img
            src={LOGO_URL}
            alt="Casagrande Brinquedos"
            className={`w-auto object-contain transition-all duration-300 ${
              scrolled ? "h-11" : "h-12"
            }`}
          />
          <ColorfulBrand className="text-xl md:text-2xl" />
        </a>

        {/* Desktop nav */}
        <nav className="hidden lg:flex items-center gap-7">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-sm font-medium text-gray-300 hover:text-white relative after:absolute after:left-0 after:-bottom-1.5 after:h-0.5 after:w-0 after:bg-[#ec4899] after:transition-all after:duration-300 hover:after:w-full transition-colors"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="hidden sm:inline-flex items-center justify-center rounded-full bg-[#22c55e] hover:bg-[#1eb253] text-white font-bold text-sm px-6 py-3 shadow-lg shadow-green-500/25 hover:shadow-green-500/40 transition-all hover:-translate-y-0.5"
          >
            PEDIR ORÇAMENTO
          </a>
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden text-white p-2"
            aria-label="Menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <nav className="lg:hidden mt-2 mx-4 rounded-2xl bg-[#13111c] border border-white/10 p-4 flex flex-col gap-1 shadow-2xl">
          {navItems.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={() => setOpen(false)}
              className="text-gray-200 hover:text-white hover:bg-white/5 rounded-xl px-4 py-3 font-medium transition-colors"
            >
              {item.label}
            </a>
          ))}
          <a
            href={WHATSAPP_LINK}
            target="_blank"
            rel="noreferrer"
            className="mt-2 text-center rounded-full bg-[#22c55e] text-white font-bold px-6 py-3"
          >
            PEDIR ORÇAMENTO
          </a>
        </nav>
      )}
    </header>
  );
};

export default Navbar;
